export const normalizeAccountHistoryValue = (value) => {
  const source = value || {};
  const hasDetails = (details) => Boolean(details) && Object.keys(details).length > 0;
  if (Array.isArray(source.departments)) {
    return source.departments.map((department) => ({
      departmentId: department?.departmentId,
      departmentName: department?.departmentName,
      projects: (department?.projects || []).map((project) => ({
        projectId: project?.projectId,
        projectName: project?.projectName,
        details: hasDetails(project?.accountDetails) ? project.accountDetails : null,
        workflows: project?.accountHistory || [],
        attachments: project?.attachments || [],
      })),
    }));
  }
  const workflows = source.accountHistory || [];
  if (!hasDetails(source.accountDetails) && workflows.length === 0) return [];
  return [
    {
      departmentId: null,
      departmentName: null,
      projects: [
        {
          projectId: null,
          projectName: null,
          details: hasDetails(source.accountDetails) ? source.accountDetails : null,
          workflows,
          attachments: source.attachments || [],
        },
      ],
    },
  ];
};

// Every attachment of a lookup -- the per-project account attachments plus each history row's own files.
export const collectAccountAttachments = (departments) =>
  (departments || []).flatMap((department) =>
    (department.projects || []).flatMap((project) => [
      ...(project.attachments || []),
      ...(project.workflows || []).flatMap((workflow) =>
        (workflow.accountHistoryList || []).flatMap((row) => row.attachments || [])
      ),
    ])
  );

export const countWorkflowTasks = (workflows) =>
  (workflows || []).reduce((total, workflow) => total + (workflow.accountHistoryList?.length ?? 0), 0);
